import { createStructuredSelector } from "reselect";
import {
    ADMIN_USER_LIST,
    ADMIN_USER_LIST_SUCCESS,
    ADMIN_USER_LIST_ERROR,
    ADMIN_USER_PAGE_SET,
    ADMIN_USER_HEADER,
    ADMIN_USER_SEARCH_SET,
    ADMIN_USER_SEARCH_CHANGE,
    ADMIN_USER_ADD_SET,
    ADMIN_USER_ADD_MODAL_SET,
    ADMIN_USER_ADD,
    ADMIN_USER_ADD_SUCCESS,
    ADMIN_USER_ADD_ERROR,
    ADMIN_USER_ADD_CHANGE,
    ADMIN_USER_EDIT_SET,
    ADMIN_USER_EDIT_CHANGE,
    ADMIN_USER_EDIT_MODAL_SET,
    ADMIN_USER_DETAIL,
    ADMIN_USER_DETAIL_SUCCESS,
    ADMIN_USER_DETAIL_ERROR,
    ADMIN_USER_UPDATE,
    ADMIN_USER_UPDATE_SUCCESS,
    ADMIN_USER_UPDATE_ERROR,
    ADMIN_USER_DETAIL_ACCESS,
    ADMIN_USER_DETAIL_ACCESS_SUCCESS,
    ADMIN_USER_DETAIL_ACCESS_ERROR,
    ADMIN_USER_DETAIL_ACCESS_MODAL_SET,
} from "../actions";

export const NAME = 'adminUser';

export const AdminUserList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: ADMIN_USER_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const AdminUserListSuccess = (data) => ({
    type: ADMIN_USER_LIST_SUCCESS,
    payload: data
});

export const AdminUserListError = (error) => ({
    type: ADMIN_USER_LIST_ERROR,
    payload: error
});

export const AdminUserPageSet = (data) => ({
    type: ADMIN_USER_PAGE_SET,
    payload: data
});

export const AdminUserHeader = (data) => ({
    type: ADMIN_USER_HEADER,
    payload: data
})

export const AdminUserSearchSet = (data) => ({
    type: ADMIN_USER_SEARCH_SET,
    payload: data
});

export const AdminUserSearchChangeSet = (data) => ({
    type: ADMIN_USER_SEARCH_CHANGE,
    payload: data
});


export const AdminUserAddChangeSet = (data) => ({
    type: ADMIN_USER_ADD_CHANGE,
    payload: data
});

export const AdminUserAddSet = (data) => ({
    type: ADMIN_USER_ADD_SET,
    payload: data
});

export const AdminUserAddModalSet = (data) => ({
    type: ADMIN_USER_ADD_MODAL_SET,
    payload: data
});

export const AdminUserAdd = (data) => ({
    type: ADMIN_USER_ADD,
    payload: data
});

export const AdminUserAddSuccess = (message) => ({
    type: ADMIN_USER_ADD_SUCCESS,
    payload: message
});

export const AdminUserAddError = (error) => ({
    type: ADMIN_USER_ADD_ERROR,
    payload: error
});


export const AdminUserEditSet = (data) => ({
    type: ADMIN_USER_EDIT_SET,
    payload: data
});

export const AdminUserEditChangeSet = (data) => ({
    type: ADMIN_USER_EDIT_CHANGE,
    payload: data
});

export const AdminUserEditModalSet = (data) => ({
    type: ADMIN_USER_EDIT_MODAL_SET,
    payload: data
});

export const AdminUserEditTabSet = (data) => ({
    type: ADMIN_USER_EDIT_TAB_SET,
    payload: data
});

export const AdminUserDetail = (data) => ({
    type: ADMIN_USER_DETAIL,
    payload: data
});

export const AdminUserDetailSuccess = (data) => ({
    type: ADMIN_USER_DETAIL_SUCCESS,
    payload: data
});

export const AdminUserDetailError = (error) => ({
    type: ADMIN_USER_DETAIL_ERROR,
    payload: error
});

export const AdminUserUpdate = (data) => ({
    type: ADMIN_USER_UPDATE,
    payload: data
});

export const AdminUserUpdateSuccess = (message) => ({
    type: ADMIN_USER_UPDATE_SUCCESS,
    payload: message.message
});

export const AdminUserUpdateError = (error) => ({
    type: ADMIN_USER_UPDATE_ERROR,
    payload: error
});

export const AdminUserDetailAccess = (data) => ({
    type: ADMIN_USER_DETAIL_ACCESS,
    payload: data
});

export const AdminUserDetailAccessSuccess = (data) => ({
    type: ADMIN_USER_DETAIL_ACCESS_SUCCESS,
    payload: data
});

export const AdminUserDetailAccessError = (error) => ({
    type: ADMIN_USER_DETAIL_ACCESS_ERROR,
    payload: error
});

export const AdminUserDetailAccessModalSet = (data) => ({
    type: ADMIN_USER_DETAIL_ACCESS_MODAL_SET,
    payload: data
});

const adminUser = (state) => state[NAME];

export const AdminUserSelector = createStructuredSelector({
    adminUser
})
